import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { CookieConsentBanner } from './banner/CookieConsentBanner.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyCookieConsentBanner = lazy<typeof CookieConsentBanner>(() =>
	// chunk name is async-ccb to avoid scripts with cookie/banner keywords getting blocked
	import(/* webpackChunkName: "async-ccb" */ './banner/CookieConsentBanner.tsx').then(
		({ CookieConsentBanner }) => CookieConsentBanner,
	),
);

export const CookieConsentBannerAsync = () => (
	<Box xcss={boxStyles}>
		<JSErrorBoundary
			id="async-cookie-consent-banner"
			packageName="jiraCookieConsentBanner"
			teamName="Magma"
		>
			<Placeholder name="async-cookie-consent-banner" fallback={null}>
				<LazyCookieConsentBanner />
			</Placeholder>
		</JSErrorBoundary>
	</Box>
);

const boxStyles = xcss({
	backgroundColor: 'elevation.surface.sunken',
	height: '100%',
});
